import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer, StyledSharedAsset, StyledList, StyledTextArea, StyledNextButton
} from '../../Interactive/WorksheetActivity/useStyles';

const NEXT_BUTTON_TEXT = 'Next';
export const THE_WORLD_NEEDS = 'theWorldNeeds';

export const WhatTheWorldNeeds = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise3.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </StyledImageContainer>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="What the world needs &#127758;"
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(THE_WORLD_NEEDS)}
      onNext={onNextHandler}
    >
      <Text size={isMobile ? 'lg' : 'sm'} bold>Ask yourself:</Text>
      <StyledList>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What problem am I solving?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>How will I make people&apos;s lives better or easier?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What&apos;s the long-term value of what I&apos;m providing?</Text>
        </li>
      </StyledList>
      <StyledTextArea
        placeholder="The world needs..."
        text={getStorageValue(THE_WORLD_NEEDS)}
        onChangeHandler={(e) => setStorageValue(THE_WORLD_NEEDS, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        className="buttonRight"
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(THE_WORLD_NEEDS)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

WhatTheWorldNeeds.propTypes = {
  onNext: PropTypes.func
};

WhatTheWorldNeeds.defaultProps = {
  onNext: () => {}
};

export default WhatTheWorldNeeds;
